module.exports = new __parcel__URL__("kitten2.1f13a3cf.png").toString();